import React, { useContext } from 'react';

import Select from 'react-select-v3';
import AsyncSelect from 'react-select-v3/async';

import { reactSelectStyles } from 'utils/style';
import { Field } from '@ontruck/orc';

import { POISearcherContext } from 'modules/point-of-interest';

const COUNTRY_OPTIONS = [
  { label: 'ES', value: 'ES' },
  { label: 'UK', value: 'UK' },
  { label: 'FR', value: 'FR' },
  { label: 'PT', value: 'PT' },
  { label: 'NL', value: 'NL' },
  { label: 'BE', value: 'BE' },
  { label: 'DE', value: 'DE' },
  { label: 'PL', value: 'PL' },
];

const t = {
  country: 'Country',
  locality: 'Locality (city, town, village...)',
  zipcode: 'Postal code',
  address: 'Postal address (street name and number)',
  venue: 'Venue or Company name',
};

const labelHiddenStyles = { display: 'none' };

const POISearcher = ({ className }) => {
  const {
    country,
    zipcode,
    locality,

    address,
    addressInputValue,

    handleCountryChange,
    handleZipcodeChange,
    handleLocalityChange,

    handleAddressChange,
    handleAddressInputChange,

    loadAddresses,

    handleSubmit,
  } = useContext(POISearcherContext);

  return (
    <div className={className} data-testid="POISearcher">
      <form onSubmit={handleSubmit} data-testid="POISearcher_form">
        <div className="header">
          <div className="row">
            <div className="field" style={{ maxWidth: 70 }}>
              <label htmlFor="country" style={labelHiddenStyles}>
                {t.country}
              </label>
              <Select
                name="country"
                inputId="country"
                options={COUNTRY_OPTIONS}
                styles={reactSelectStyles}
                placeholder={t.country}
                onChange={handleCountryChange}
                value={country}
              />
            </div>
            <div className="field" style={{ maxWidth: 80 }}>
              <label htmlFor="zipcode" style={labelHiddenStyles}>
                {t.zipcode}
              </label>
              <Field
                id="zipcode"
                name="zipcode"
                label={t.zipcode}
                fullWidth
                value={zipcode}
                onChange={handleZipcodeChange}
              />
            </div>
            <div className="field">
              <label htmlFor="locality" style={labelHiddenStyles}>
                {t.locality}
              </label>
              <Field
                id="locality"
                name="locality"
                label={t.locality}
                value={locality}
                fullWidth
                onChange={handleLocalityChange}
                disabled={!zipcode}
              />
            </div>
          </div>
          <div className="row">
            <div className="field">
              <label htmlFor="address" style={labelHiddenStyles}>
                {t.address}
              </label>
              <AsyncSelect
                name="address"
                inputId="address"
                styles={reactSelectStyles}
                placeholder={t.address}
                loadOptions={loadAddresses}
                defaultOptions={false}
                isDisabled={!zipcode || !locality}
                value={address}
                onChange={handleAddressChange}
                onInputChange={handleAddressInputChange}
                inputValue={addressInputValue}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default POISearcher;
